export const CognitoPermissionGroups = {
  // Multi feature access
  isService: 'isService',
  isSales: 'isSales',
  isInternalSales: 'isInternalSales',
  isExternalSales: 'isExternalSales',
  isTeamLeader: 'isTeamLeader',
  isAgency: 'isAgency',
  isInternalAgent: 'isInternalAgent',
  isUnlicensed: 'isUnlicensed', // completely unlicensed, no access to quote in any state
  canAccessProtectedUDDActions: 'canAccessProtectedUDDActions',

  // Individual feature access
  canQuote: 'canQuote',
  canEditPolicies: 'canEditPolicies',
  canEditOffers: 'canEditOffers',
  canViewPolicies: 'canViewPolicies',
  canViewOffers: 'canViewOffers',
  canEdit: 'canEdit',
  canBind: 'canBind',
  canBindDirectly: 'canBindDirectly',
  canViewCheckoutPage: 'canViewCheckoutPage',
  canReinstate: 'canReinstate',
  canRescindCancellation: 'canRescindCancellation',
  canSeeFullOfferDetails: 'canSeeFullOfferDetails',
  canScrubIncidents: 'canScrubIncidents',
  canModifyAffinityAndLeadSource: 'canModifyAffinityAndLeadSource',
  canBackDate: 'canBackDate',
  canUploadDocuments: 'canUploadDocuments',
  canDeleteInternalDocuments: 'canDeleteInternalDocuments',
  canOverrideAllRejections: 'canOverrideAllRejections',
  canModifyBillingId: 'canModifyBillingId',
  canViewClarionDoorData: 'canViewClarionDoorData',
  canAddCarsManually: 'canAddCarsManually',
  canAutoRenew: 'canAutoRenew',
  canAddHoldCards: 'canAddHoldCards',
  canChangeExclusions: 'canChangeExclusions',
  canToggleEmployeeDiscount: 'canToggleEmployeeDiscount',
  canClearUDRs: 'canClearUDRs',
  viewOnly: 'viewOnly',
  canEditHomeAddress: 'canEditHomeAddress',
  canEditEffectiveDate: 'canEditEffectiveDate',
  canManuallyChargeFee: 'canManuallyChargeFee',
  canQuoteBranchPlus: 'canQuoteBranchPlus',
  canClearUWFormRejections: 'canClearUWFormRejections',
  canManuallyChargePolicy: 'canManuallyChargePolicy',
  canRewritePolicy: 'canRewritePolicy',
  canRemoveExcludedDriver: 'canRemoveExcludedDriver',
  canCancelReasonCNIP: 'canCancelReasonCNIP',
  canCancelReasonCNMS: 'canCancelReasonCNMS',
  canCancelReasonCNPY_X: 'canCancelReasonCNPY_X',
  canRejectPIP: 'canRejectPIP',
  showAgencyPortal: 'showAgencyPortal',
  canDownloadAnonDocs: 'canDownloadAnonDocs',
  canReinstateCNPY: 'canReinstateCNPY',
  canToggleCreditCheck: 'canToggleCreditCheck',
  canEditBillingDay: 'canEditBillingDay',
  canToggleCHDiscount: 'canToggleCHDiscount',
  canToggleInventoryDiscount: 'canToggleInventoryDiscount',
  canEditPolicyMPD: 'canEditPolicyMPD',
  canDelayPaymentOrRefund: 'canDelayPaymentOrRefund',
  canManageBillingHolds: 'canManageBillingHolds',
  canSendPaperDocs: 'canSendPaperDocs',
  canEditFeeCheckbox: 'canEditFeeCheckbox',
  canOverrideGaragingAddress: 'canOverrideGaragingAddress',
  canSwapApplicants: 'canSwapApplicants',
  canViewCarrierInitiatedCancels: 'canViewCarrierInitiatedCancels',
  canSellAndService: 'canSellAndService',
  canCancelReasonNACP: 'canCancelReasonNACP',
  canEditUneditablePropertyDetailsFields: 'canEditUneditablePropertyDetailsFields',
  canResetOnboardingTasks: 'canResetOnboardingTasks',
  canCancelOnboardingTasks: 'canCancelOnboardingTasks',
  canViewInternalTasks: 'canViewInternalTasks',
  canViewUWCancelCodes: 'canViewUWCancelCodes',
  canToggleIsAgencyPolicy: 'canToggleIsAgencyPolicy',
  canSkipEmailConfirmationSplashPage: 'canSkipEmailConfirmationSplashPage',
  canRefundStripePayment: 'canRefundStripePayment',
  canRescindOrReinstateGSNICPolicy: 'canRescindOrReinstateGSNICPolicy',
  canRemoveFinalPaymentMethod: 'canRemoveFinalPaymentMethod',
  canBypassDriversLicenseCheck: 'canBypassDriversLicenseCheck',
  canSeeMarketTierCard: 'canSeeMarketTierCard',
  canEditCoverageA: 'canEditCoverageA',
  canWriteMultipleAffinityCodes: 'canWriteMultipleAffinityCodes',
  canEditDriversName: 'canEditDriversName',
  canModifyNonRatedIndividual: 'canModifyNonRatedIndividual',
  canUploadTaskCenterDocuments: 'canUploadTaskCenterDocuments',
  canRevertPolicyDetails: 'canRevertPolicyDetails',
  canToggleHomeRepairsRequested: 'canToggleHomeRepairsRequested',
  canEditPriorCarrierDetails: 'canEditPriorCarrierDetails',
  canSkipOfferUnderwritingRules: 'canSkipOfferUnderwritingRules',
  canEditFarmPolicyAdjustment: 'canEditFarmPolicyAdjustment',
  canApproveUWReview: 'canApproveUWReview',

  // tools permissions
  canViewTools: 'canViewTools',
  canViewAffinityTools: 'canViewAffinityTools',
  canViewStaffDashboard: 'canViewStaffDashboard',
  canGenerateDescopePasskeyReport: 'toolsCanGenerateDescopePasskeyReport',
  canResetStaffUserPassword: 'canResetStaffUserPassword',
  canCreateStripeCharge: 'canCreateStripeCharge',
  canCreateChargedeskInvoice: 'canCreateChargedeskInvoice',
  canBulkDisableStaffUsers: 'canBulkDisableStaffUsers',
  canCreateChargedeskRefundInvoice: 'canCreateChargedeskRefundInvoice',
  canRegeneratePolicyForm: 'canRegeneratePolicyForm',
  canUpdateChargedeskRecord: 'canUpdateChargedeskRecord',
  canUpdateChargedeskRecordPolicyOrBillingId: 'canUpdateChargedeskRecordPolicyOrBillingId',
  canGenerateRenewal: 'canGenerateRenewal',
  canRunRenewalUnderwriting: 'canRunRenewalUnderwriting',
  canUpdateStaffUser: 'canUpdateStaffUser',
  canDisableStaffUser: 'canDisableStaffUser',
  canViewEditGroups: 'canViewEditGroups',
  canRunAddressesThroughCherre: 'canRunAddressesThroughCherre',
  canUpdatePolicyRep: 'canUpdatePolicyRep',
  canAddPermissionGroupsToStaffUsers: 'canAddPermissionGroupsToStaffUsers',
  canCreateStaffUser: 'canCreateStaffUser',
  canCreateFrontTicket: 'canCreateFrontTicket',
  canViewStateRateChangeDashboard: 'canViewStateRateChangeDashboard',
  canImportPoliciesToSnapsheet: 'canImportPoliciesToSnapsheet',
  canImportPoliciesToIvans: 'canImportPoliciesToIvans',
  canRegeneratePolicyCancelForm: 'canRegeneratePolicyCancelForm',
  canAddCatTagsToClaims: 'canAddCatTagsToClaims',
  canRunBillingActions: 'canRunBillingActions',
  canRunCorrectiveActions: 'canRunCorrectiveActions',
  canRunIvansActions: 'canRunIvansActions',
  canCopyPolicy: 'canCopyPolicy',
  canSetMemberAffinity: 'canSetMemberAffinity',
  canEnableStaffUser: 'canEnableStaffUser',
  canResetPasskeys: 'canResetPasskeys',
  canRunTechTasks: 'canRunTechTasks',
  canPullDrivingHistoryFromCSV: 'canPullDrivingHistoryFromCSV',
  canSetHasAutoPolicy: 'canSetHasAutoPolicy',
  canUpdateBillingId: 'canUpdateBillingId',
  canOverrideUmbrellaLimit: 'canOverrideUmbrellaLimit',
  canChangeOfferAffinity: 'canChangeOfferAffinity',
  canUpdateStaffUsername: 'canUpdateStaffUsername',
  canUpdateMortgage: 'canUpdateMortgage',
  canBackfillData: 'canBackfillData',
  canCreateCompaniesInRoutable: 'canCreateCompaniesInRoutable',
  canSkipMatchingActivePolicySearch: 'canSkipMatchingActivePolicySearch',
  canViewPolicyOverridesTool: 'canViewPolicyOverridesTool',
  canViewOfferOverridesTool: 'canViewOfferOverridesTool',
  canBulkOrderInspections: 'canBulkOrderInspections',
  canOverrideBrandedTitle: 'canOverrideBrandedTitle',
  canOverrideMSRP: 'canOverrideMSRP',
  canOverrideExcludedCar: 'canOverrideExcludedCar',
  canOverrideLoanNumVal: 'canOverrideLoanNumVal',
  canOverrideApplicationSigningExpiry: 'canOverrideApplicationSigningExpiry',
  canBulkDownloadPolicyDocuments: 'canBulkDownloadPolicyDocuments',
  canAllowWaterBackup: 'canAllowWaterBackup',
  canAllowAuxRating: 'canAllowAuxRating',
  canViewAiValidation: 'canViewAiValidation',
  canSeeHomeCharacteristicsDataset: 'canSeeHomeCharacteristicsDataset',
  canRefreshCharacteristicsAndRateOffer: 'canRefreshCharacteristicsAndRateOffer',
  toolsDeleteRenewalSegment: 'toolsDeleteRenewalSegment',
  canRemoveAutoViolation: 'canRemoveAutoViolation',
  canAddHomeClaim: 'canAddHomeClaim',
  toolsOverrideReplacementCost: 'toolsOverrideReplacementCost',
  canRetryOfferOptions: 'canRetryOfferOptions',
  toolsCreateUddReviewTask: 'toolsCreateUddReviewTask',
  canSimulateSource: 'canSimulateSource',
  canManageDialpadCampaigns: 'canManageDialpadCampaigns',
  canExportEasyKeyXML: 'canExportEasyKeyXML',
  toolsAllOverridesAccess: 'toolsAllOverridesAccess'
};

export const PermissionRequireTypes = {
  All: 'all',
  AtLeastOne: 'atLeastOne'
};
